import { ConfigProps } from '@/types/ConfigProps'

class Config {
    configSaveTime = 0
    channelsVersion
    configVersion
    epgVersion
    tvUpdateIntervals
    skin
    termsAndConditions
    epgPresentFollowingCdnUriFile?
    epgScheduleCdnUriPrefix?
    shouldAuthenticateEpgFiles?
    rentalUri?
    faqUrl
    privacyPolicyUrl

    constructor(configProps: ConfigProps) {
        this.epgPresentFollowingCdnUriFile =
            configProps.epgPresentFollowingCdnUriFile
        this.epgScheduleCdnUriPrefix = configProps.epgScheduleCdnUriPrefix
        this.shouldAuthenticateEpgFiles = configProps.shouldAuthenticateEpgFiles
        this.channelsVersion = configProps.channelsVersion
        this.configVersion = configProps.configVersion
        this.epgVersion = configProps.epgVersion
        this.tvUpdateIntervals = configProps.tvUpdateIntervals
        this.configSaveTime = configProps.configSaveTime
        this.skin = configProps.skin
        this.termsAndConditions = configProps.termsAndConditions
        this.rentalUri = configProps.rentalUri
        this.faqUrl = configProps.faqUrl
        this.privacyPolicyUrl = configProps.privacyPolicyUrl
    }

    equals = (otherConfig: Config) => {
        if (otherConfig) {
            const stringifiedOtherConfig = JSON.stringify(otherConfig)
            const stringifiedThisConfig = JSON.stringify(this)
            return stringifiedOtherConfig === stringifiedThisConfig
        } else return null
    }

    getConfigSaveTime = () => {
        const actualSecondsDate = Math.floor(Date.now() / 1000)
        this.configSaveTime = actualSecondsDate
    }

    checkTimeIfConfigNeedsUpdate = () => {
        if (this.tvUpdateIntervals) {
            const actualSecondsDate = Math.floor(Date.now() / 1000)
            const randomlyAddOrSubtract =
                Math.floor(Math.random() * 2) === 1 ? 1 : -1
            const secondsSinceConfigWasSaved =
                actualSecondsDate - this.configSaveTime
            const secondsToNextConfigUpdate =
                this.tvUpdateIntervals.configUpdateIntervalOnSuccess +
                (randomlyAddOrSubtract *
                    this.tvUpdateIntervals.configUpdateIntervalMaxDeviation) /
                    2

            //new config update attempt
            if (secondsSinceConfigWasSaved >= secondsToNextConfigUpdate)
                return true
        }
        return false
    }
}

export default Config
